import {User} from "../types/types";

export const dummyStudent = {
    id: 1,
    user_id: 2,
    full_name: "Steven Vu",
    age: 20,
    school: "School of School",
    bio: "Boss",
    interests: "Sports",
    email: "stevenvu2468@gmail.com",
    phone: "123-456-7890",
    upcoming_events: 0,
    past_events: 0,
}